module.exports = __webpack_public_path__ + "img/36.895b1c7f.jpg";